import { SEARCH_FILTER_OUTSIDE_CLICK } from "./actionTypes";

export default () => ({
  type: SEARCH_FILTER_OUTSIDE_CLICK,
  payload: {
  }
});